module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', _vm._b({
    ref: "formitem",
    staticClass: "rt-form-item-wrapper",
    attrs: {
      "label": _vm.label,
      "prop": _vm.prop
    }
  }, 'el-form-item', _vm.$attrs, false), [(!_vm.label) ? _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1aea9f6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/form/rtFormItem.vue
// module id = 1468
// module chunks = 124